module.exports = __webpack_public_path__ + "img/articles@2x.c581358.png";